module.exports = __webpack_public_path__ + "img/virtual_pub_modal.48c076be.png";